import { FC } from 'react'
import { Image } from 'components/Image'

export const CobrandedPartnerLogo: FC<
  React.PropsWithChildren<{ logoUrl: string | null | undefined }>
> = (props) => {
  return (
    <Image
      src={props.logoUrl}
      css={{
        maxHeight: '2rem',
      }}
    />
  )
}
